<template>
  <div>
    <AppWthdr
      v-if="viewToggle"
      @viewToggleEmit="viewToggleChange"
      :appDeviceId="appDeviceId"
      :fcmFlag="fcmFlag"
    />
    <div class="app-wrap">
      <AppSettingHeader/>
      <ul class="setting-list">
        <li>
          <div class="menu-list-item push" :class="fcmFlagClass" @click="appPushToggle">
            <span>푸시 수신</span>
          </div>
          <div>
            <span>주문상태 알림을 푸시로 받아보시려면<br>시스템 앱 알림 설정을 먼저 허용해주세요.</span>
          </div>
        </li>
        <li>
          <div class="menu-list-item push" :class="autoLoginFlagClass" @click="autoLoginFlagToggle">
            <span>자동로그인</span>
          </div>
          <div>
            <span>자동로그인 해제 전까지 로그인 상태가 유지됩니다.</span>
          </div>
        </li>
        <li>
          <div>
            <span>현재 버전 v{{appVersion}}</span>
          </div>
          <div>
            <span v-if="appVersion == latestAppVersion">현재 최신 버전 사용중입니다</span>
            <span v-else>최신 버전 v{{latestAppVersion}}</span>
          </div>
        </li>
        <!-- <li class="menu-list-item" @click="appLogout">로그아웃</li> -->
      </ul>
      <div class="member-withdraw">
        <button class="member-wthdr" @click="viewToggleChange">회원탈퇴</button>
      </div>
    </div>
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='doubleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'
      :imgFlag='false'/>
  </div>
</template>

<script lang="js">
import service from '@/backend/modnpay_app_api'
import AppSettingHeader from '@/components/Header/AppSettingHeader.vue'
import AppWthdr from '@/views/AppWthdrPage.vue'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
import { MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
/* eslint-disable eqeqeq */
export default {
  components: {
    AppSettingHeader,
    AppWthdr,
    DoubleBtnDialog
  },
  data () {
    return {
      showDoubleBtnDialogFlag: false,
      onClickConfirmBtn: undefined,
      onClickCancelBtn: undefined,
      fcmFlag: false, // 앱 푸쉬 설정
      appPushFlag: false, // 시스템 푸쉬 설정
      autoLoginFlag: false,
      appDeviceId: 0,
      disabledFlag: false,
      appVersion: '',
      latestAppVersion: '',
      today: '',
      fcm: '푸시',
      autoLogin: '자동로그인',
      query: this.$route.query
    }
  },
  created () {
    if (Object.keys(this.query).length) {
      this.viewToggle = this.query.viewToggle
    }
    this.appPushReceive()
    this.findAppSetting()
  },
  mounted () {
    this.toDaySet()
  },
  methods: {
    showDoubleBtnDialog (message, confirmBtn) {
      this.doubleBtnMsgType = message
      this.onClickConfirmBtn = confirmBtn
      this.onClickCancelBtn = this.hideDoubleBtnDialog
      this.showDoubleBtnDialogFlag = true
    },
    hideDoubleBtnDialog () {
      this.showDoubleBtnDialogFlag = false
    },
    toDaySet () {
      const date = new Date()
      this.today = date.getFullYear() + '.' + (('00' + (date.getMonth() + 1)).slice(-2)) + '.' + (('00' + date.getDate()).slice(-2))
    },
    // 푸쉬 수신
    fcmFlagToggle () {
      this.fcmFlag = !this.fcmFlag
      this.updateAppSetting(this.fcm)
    },
    // 자동로그인
    autoLoginFlagToggle () {
      this.autoLoginFlag = !this.autoLoginFlag
      this.updateAppSetting(this.autoLogin)
    },
    appPushToggle () {
      this.appPushReceive()
      setTimeout(() => {
        if (this.appPushFlag == false && this.fcmFlag == false) {
          this.showDoubleBtnDialog(MESSAGE_DOUBLE_BUTTON[11], () => {
            this.openSettingsApp() // 앱설정이동
            this.showDoubleBtnDialogFlag = false
          })
        } else {
          this.fcmFlagToggle() // 백엔드 api
        }
      }, 100)
    },
    // 앱 설정 정보 조회
    async findAppSetting () {
      const req = {
        userCode: ''
      }
      const { data } = await service.findAppSetting(req)
      const code = data.resultCode

      if (code == 0) {
        this.fcmFlag = Boolean(data.fcmFlag)
        if (this.fcmFlag && this.appPushFlag) {
          this.fcmFlag = true
        } else {
          this.fcmFlag = false
        }
        this.autoLoginFlag = Boolean(data.autoLoginFlag)
        this.appDeviceId = data.appDeviceId
        this.appVersion = data.appVersion
        this.latestAppVersion = data.latestAppVersion
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    // 앱 설정 정보 업데이트
    async updateAppSetting (flagName) {
      const req = {
        userCode: '',
        appDeviceId: this.appDeviceId,
        fcmFlag: Number(this.fcmFlag),
        autoLoginFlag: Number(this.autoLoginFlag)
      }
      const { data } = await service.updateAppSetting(req)
      const code = data.resultCode

      if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else if (code != 0) {
        THROW_APP_ERROR()
      } else if (code == 0) {
        let toastMsg = ''
        if (flagName == this.autoLogin) {
          toastMsg = this.autoLoginFlag
            ? this.today + '<br/>' + flagName + ' 설정 완료되었습니다.'
            : this.today + '<br/>' + flagName + ' 설정 해제 완료되었습니다.'
        } else {
          toastMsg = this.fcmFlag
            ? this.today + '<br/>주문관련 앱 ' + flagName + ' 알림 동의 완료되었습니다.'
            : this.today + '<br/>주문관련 앱 ' + flagName + ' 알림 거부 완료되었습니다.'
        }
        this.toast(this, toastMsg)
      }
    },
    // 로그아웃
    async appLogout () {
      const req = {
        userCode: ''
      }
      const { data } = await service.appLogout(req)
      const code = data.resultCode

      if (code == 0) {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('encPasswd')
        this.$router.push({ name: 'AppLogin' })
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    }
  },
  computed: {
    fcmFlagClass () { // 푸시
      return this.fcmFlag ? 'active' : ''
    },
    autoLoginFlagClass () { // 자동로그인
      return this.autoLoginFlag ? 'active' : ''
    }
  }
}
</script>

<style>
.setting-list > li {
  box-shadow: 0px 1px 0px 0px rgba(13,13,13,0.1) !important;
}
.setting-list > li > div:nth-child(1) {
  margin: 16px 16px 0px;
  padding: unset !important;
  font-family: NotoSansCJKkr;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  color: #0d0d0d;
  font-size: 16px;
}
.setting-list li > div:nth-child(2){
  padding: 8px 0px 16px;
  margin: 0px 16px 16px;
  font-family: NotoSansCJKkr;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #818181;
}
/* .setting-list > li:nth-child(1) > div {
  padding: 16px 0px !important;
  margin: 0px 16px;
} */
.setting-list .menu-list-item:before {
  right: 0px !important;
}
.setting-list .menu-list-item:after {
  box-shadow: unset !important;
}
</style>
